// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Row$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/custom/layout-components/Row.bs.js";
import * as ButtonUtils$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/ButtonUtils.bs.js";
import * as SendSMSAssetsManager from "../assets/SendSMSAssetsManager.bs.js";
import * as PrimaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/PrimaryButton.bs.js";
import * as SecondaryButton$Catalyst from "../../../../../../node_modules/@porterin/catalyst/src/components/generic/buttons/SecondaryButton.bs.js";

function SidePanelFooter(Props) {
  var on_primary_btn_click = Props.on_primary_btn_click;
  var on_secondary_btn_clickOpt = Props.on_secondary_btn_click;
  var show_secondary_btnOpt = Props.show_secondary_btn;
  var is_disabledOpt = Props.is_disabled;
  var is_loading = Props.is_loading;
  var class_nameOpt = Props.class_name;
  var loader_msgOpt = Props.loader_msg;
  var primary_btn_textOpt = Props.primary_btn_text;
  var on_secondary_btn_click = on_secondary_btn_clickOpt !== undefined ? on_secondary_btn_clickOpt : (function (param) {
        
      });
  var show_secondary_btn = show_secondary_btnOpt !== undefined ? show_secondary_btnOpt : false;
  var is_disabled = is_disabledOpt !== undefined ? is_disabledOpt : false;
  var class_name = class_nameOpt !== undefined ? class_nameOpt : "";
  var loader_msg = loader_msgOpt !== undefined ? loader_msgOpt : "";
  var primary_btn_text = primary_btn_textOpt !== undefined ? primary_btn_textOpt : "Next";
  var loading = SendSMSAssetsManager.getImage("loading.svg");
  return React.createElement("div", {
              className: "footer u-align-self-flex-end " + class_name
            }, React.createElement(Row$Catalyst.make, {
                  children: is_loading ? React.createElement(React.Fragment, undefined, React.createElement("img", {
                              src: loading
                            }), React.createElement("div", {
                              className: "loading-text ml-1"
                            }, loader_msg)) : React.createElement("div", {
                          className: "buttons"
                        }, show_secondary_btn ? React.createElement(SecondaryButton$Catalyst.make, {
                                buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps({
                                      TAG: /* Text */0,
                                      _0: "Back"
                                    }, undefined, (function (_event) {
                                        return Curry._1(on_secondary_btn_click, undefined);
                                      }), undefined, undefined, undefined, undefined, "c-mui-secondary-next-btn back-button ", undefined, undefined)
                              }) : null, React.createElement(PrimaryButton$Catalyst.make, {
                              buttonProps: ButtonUtils$Catalyst.getDefaultButtonProps(show_secondary_btn ? ({
                                        TAG: /* Text */0,
                                        _0: "Submit"
                                      }) : ({
                                        TAG: /* Text */0,
                                        _0: primary_btn_text
                                      }), is_disabled, (function (_event) {
                                      return Curry._1(on_primary_btn_click, undefined);
                                    }), undefined, undefined, undefined, undefined, "c-mui-primary-next-btn next-button " + (
                                    is_disabled ? "disabled-button" : ""
                                  ), undefined, undefined)
                            }))
                }));
}

var make = SidePanelFooter;

export {
  make ,
  
}
/* react Not a pure module */
